import React from 'react'
import { Chip, Tooltip } from '@material-ui/core';
import { useState } from 'react';
import { PreviewDocsModal } from '../../../../shared_elements';
export default function UtilsAttachments({ data }) {
    const [previewDoc, setPreviewDoc] = useState(false)
    return (
        <div style={{marginBottom:"15px"}}>
            <h5 className='para invoice-heading' style={{marginBottom:"5px"}}>Utilization Reports</h5>
            <ul className="list-inline" style={{paddingLeft:'14px'}}>
                {data?.map(item => (
                    <li className="list-inline-item">
                        <Tooltip title={item?.name} arrow placement='top' style={{ marginTop: '3px' }}>
                            <Chip
                                variant="outlined"
                                size="small"
                                label={`${item.name.substring(0, 24)} ${item.name?.length > 24 ? '...':''}`}
                                clickable
                                color="primary"
                                onClick={() => setPreviewDoc(item)}
                            />
                        </Tooltip>
                    </li>
                ))
                }
            </ul>
            {previewDoc ?
                <PreviewDocsModal previewDocs={previewDoc} toggleModalFn={() => setPreviewDoc("")} />
                : null
            }
        </div>
    )
}
